import { IComponentController, IComponentOptions } from 'angular';
import { TnSelect2Option } from '../tn-select-2/tn-select-2';
import template from './tn-date-select-2.html';

const monthOptions = [
    { value: 0, label: 'January' },
    { value: 1, label: 'February' },
    { value: 2, label: 'March' },
    { value: 3, label: 'April' },
    { value: 4, label: 'May' },
    { value: 5, label: 'June' },
    { value: 6, label: 'July' },
    { value: 7, label: 'August' },
    { value: 8, label: 'September' },
    { value: 9, label: 'October' },
    { value: 10, label: 'November' },
    { value: 11, label: 'December' },
];

export class TnDateSelect2Component implements IComponentController {
    // bindings
    date?: Date;
    label?: string;
    minDate: Date = new Date(2015, 0);
    maxDate: Date = new Date();
    monthPlaceholder = 'Month';
    yearPlaceholder = new Date().getFullYear().toString();
    onChange?: ({ value }) => void;

    // locals
    _month?: number = this.date?.getMonth();
    _year?: number = this.date?.getFullYear();
    _yearOptions: TnSelect2Option[] = [];
    _monthOptions: TnSelect2Option[] = monthOptions;

    $onInit(): void {
        const minYear = (this.minDate && this.minDate.getFullYear()) || 2015;
        const maxYear =
            (this.maxDate && this.maxDate.getFullYear()) ||
            new Date().getFullYear();
        for (let i = minYear; i < maxYear; ++i) {
            this._yearOptions.push({ value: i, label: i.toString() });
        }
    }

    selectYear(year: number): void {
        this._year = this._year == year ? undefined : year;
        this.update();
    }

    selectMonth(month: number): void {
        // if we click on an already selected month, unselect it.
        this._month = this._month == month ? undefined : month;
        this.update();
    }

    // set or update the date on changes.
    update(): void {
        if (this._year === undefined || this._month == undefined) {
            return this.onChange && this.onChange({ value: undefined });
        }
        if (this._year !== undefined && this._month !== undefined) {
            const value = new Date(this._year, this._month);
            this.onChange && this.onChange({ value });
        }
    }
}

export const TnDateSelect2ComponentOptions: IComponentOptions = {
    bindings: {
        label: '@',
        date: '<',
        minDate: '<',
        maxDate: '<',
        monthPlaceholder: '@',
        yearPlaceholder: '@',
        onChange: '&',
    },
    controller: TnDateSelect2Component,
    template,
};
